import { Command } from "commander";
import chalk from "chalk";
import Table from "cli-table3";
import { loadData } from "@fathom/core";
import { getConvexClient, logConvexStatus } from "../convex-client.js";
import { api } from "../../../../convex/_generated/api.js";
import { withSpinner } from "../ux/spinner.js";
import { fatalError } from "../ux/errors.js";

export const pricingCommand = new Command("pricing")
  .description("Show current model pricing")
  .option("--sync", "Sync pricing data to Convex")
  .action(async (options: { sync?: boolean }) => {
    let data;
    try {
      data = loadData();
    } catch (err) {
      fatalError(
        "Cannot load pricing data",
        (err as Error).message,
        "Run `fathom init` to set up the project, or check data/models.yaml",
      );
    }

    console.log(chalk.bold("\nFathom — Model Pricing"));
    console.log(chalk.dim("─".repeat(65)));

    const table = new Table({
      head: [
        chalk.white("Model"),
        chalk.white("Tier"),
        chalk.white("Input/MTok"),
        chalk.white("Output/MTok"),
        chalk.white("Cache Read"),
        chalk.white("Batch"),
      ],
      colAligns: ["left", "center", "right", "right", "right", "right"],
    });

    for (const m of data.models) {
      table.push([
        m.name,
        m.tier,
        `$${m.input_per_mtok.toFixed(2)}`,
        `$${m.output_per_mtok.toFixed(2)}`,
        `$${m.cache_read_per_mtok.toFixed(2)}`,
        `${(m.batch_discount * 100).toFixed(0)}% off`,
      ]);
    }

    console.log(table.toString());
    console.log(chalk.dim("\nSource: data/models.yaml — update via `fathom research`"));

    // Sync pricing to Convex if requested
    if (options.sync) {
      const client = getConvexClient();
      if (client) {
        const synced = await withSpinner("Fetching latest pricing data...", async () => {
          let count = 0;
          for (const m of data.models) {
            try {
              await client.mutation(api.modelPricing.upsert, {
                model: m.name,
                provider: "anthropic",
                inputPerMTok: m.input_per_mtok,
                outputPerMTok: m.output_per_mtok,
                cacheReadPerMTok: m.cache_read_per_mtok,
                batchDiscount: m.batch_discount,
              });
              count++;
            } catch {
              // skip individual failures
            }
          }
          return count;
        });
        logConvexStatus(synced > 0);
        if (synced > 0) {
          console.log(chalk.dim(`  ${synced} models synced to Convex.`));
        }
      } else {
        logConvexStatus(false);
      }
    }

    console.log();
  });
